import { endpointRequest } from '../EndpointService/EndpointFunctions';

export default function createUserService(jokiInstance) {
    const serviceId = 'UserService';
    const joki = jokiInstance;
    let userInfo = null;

    function messageHandler(event) {
        switch (event.key) {
            case 'getCurrentUser':
                // console.log("UserService:messageHandler:getCurrentUser", userInfo);
                if (userInfo === null) {
                    fetchUserInfo();
                    return {};
                }
                return userInfo;
            case 'updateUserInfo':
                fetchUserInfo();
                break;
            default:
                break;
        }
    }

    async function fetchUserInfo() {
        // console.log("UserService:fetchUserInfo: ", userInfo);

        try {
            const results = await endpointRequest(joki, 'user_info');
            if (results !== undefined) {
                userInfo = results;
                _triggerUserDataUpdate();
            } else {
                throw new Error(`${serviceId}:fetchUserInfo: results from endpoint are undefined!`);
            }
        } catch (err) {
            console.error(`${serviceId}:fetchUserInfo Could not retrieve user information!\n`, err);
        }

        // joki.ask({
        //     to: "FetchService",
        //     key: "cachedRequest",
        //     body: {
        //         url: "me",
        //         method: "GET",
        //     },
        // })
        //     .then(response => {
        //         if (response !== undefined && response.FetchService !== undefined) {
        //             response.FetchService.then(data => {
        //                 userInfo = data;
        //                 _triggerUserDataUpdate();
        //             });
        //         }
        //     })
        //     .catch(err => {
        //         console.error("CANNOT RETRIEVE THE USER", err);
        //     });
    }

    function _triggerUserDataUpdate() {
        joki.broadcast({
            from: serviceId,
            key: 'currentUserUpdated',
            body: userInfo,
        });
    }

    joki.addService({
        id: serviceId,
        fn: messageHandler,
    });
}
